<template>
  <div class="demandReport" id="pickUp">
    <div class="leftDiv">
      <div class="leftTopDiv">
        <div class="userInfoClass">
          <div class="photo">
            <img v-if="userInfo.iconUrl" :src="userInfo.iconUrl" />
          </div>
          <div class="basicInfo">
            <tooltip-over
              :content="userInfo.username"
              :className="'username'"
              class="wid190"
              refName="username"
            ></tooltip-over>
            <div class="line"></div>
            <tooltip-over
              :content="'账号:' + userInfo.userNo"
              :className="'userNo'"
              class="wid190"
              refName="userNo"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.departmentName"
              :className="'departmentName'"
              class="wid190"
              refName="departmentName"
            ></tooltip-over>
            <tooltip-over
              :content="userInfo.roleName"
              :className="'roleName'"
              class="wid190"
              refName="roleName"
            ></tooltip-over>
          </div>
          <div class="logOut" @click="logOut()"></div>
        </div>
        <div class="statistics">
          <div class="planNum" :style="opacityOfPlan" @click="plan">
            <div class="title">计划列表</div>
            <div class="num">{{ planNum }}</div>
          </div>
          <div class="waitConfirm" :style="opacityOfWaitConfirm" @click="waitConfirm">
            <div class="title">待收货</div>
            <div class="num">{{ waitConfirmNum }}</div>
          </div>
          <div class="confirmed" :style="opacityOfConfirmed" @click="confirmed">
            <div class="title">已收货</div>
            <div class="num">{{ confirmedNum }}</div>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="contentClass">
          <!-- <div class="tableTitle">任务计划列表</div> -->
          <div class="contentTable" ref="contentTable">
            <el-table
              :data="taskList"
              @row-click="clickTaskRow"
              ref="taskList"
              :max-height="taskPlanTableAutoHeight"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                prop="flight_local_id"
                label="计划编号"
                min-width="80"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="flight_name"
                label="计划名称"
                align="center"
                min-width="100"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                label="优先级"
                align="center"
                min-width="55"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.flight_pirority === 1">低</span>
                  <span v-else-if="scope.row.flight_pirority === 2">中</span>
                  <span v-else-if="scope.row.flight_pirority === 3">高</span>
                </template>
              </el-table-column>
              <el-table-column
                label="当前状态"
                align="center"
                min-width="55"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.flight_status === 10">规划中</span>
                  <span v-else-if="scope.row.flight_status === 15">已提交/待环境确认</span>
                  <span v-else-if="scope.row.flight_status === 20">待审核</span>
                  <span v-else-if="scope.row.flight_status === 30">驳回/审批拒绝</span>
                  <span v-else-if="scope.row.flight_status === 40">待发货</span>
                  <span v-else-if="scope.row.flight_status === 50">待飞行</span>
                  <span v-else-if="scope.row.flight_status === 60">正在飞行</span>
                  <span v-else-if="scope.row.flight_status === 70">飞行结束</span>
                  <span v-else-if="scope.row.flight_status === 90">确认收货</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="searchArea">
            <div class="desc">计划搜索</div>
            <div class="separate"></div>
            <el-form :model="queryForm" @submit.native.prevent>
              <el-form-item label="">
                <el-input
                  class="inputClass"
                  v-model="queryForm.keyword"
                  @keyup.enter.native="getConfrimRelationListByDestination()"
                >
                  <i
                    class="el-icon-search-img"
                    slot="suffix"
                    @click="getConfrimRelationListByDestination()"
                  >
                  </i></el-input
              ></el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="rightDiv" v-show="isDetail">
      <!-- 添加div.rightTop和div.rightBottom两个容器，把我右侧分为上下两个 -->
      <div class="rightTop">
        <div class="header">
          <div class="taskInfo">
            <tooltip-over
              :content="flight.local_id"
              :className="'content'"
              class="wid190"
              refName="local_id"
            ></tooltip-over>
            <div class="title">计划编号</div>
          </div>
          <div class="goodsInfo">
            <tooltip-over
              :content="goodsName"
              :className="'content'"
              class="wid190"
              refName="goodsName"
            ></tooltip-over>
            <div class="title">货物名称</div>
          </div>
          <div class="priority">
            <el-image :src="priority" :class="priorityClassName" />
          </div>
          <div :class="codeDivClass" v-show="isWaitConfirm">
            <div class="codeBefore" @click="clickToShowCode">
              <el-image :src="codeBefore" class="codeBeforeClass" />
              <div class="showCode">点击扫码</div>
            </div>
          </div>
        </div>
        <div class="seperate"></div>
        <div class="createInfo">
          <div class="title">创建时间:</div>
          <div class="content">{{ flight.created_at }}</div>
          <div class="title">提交账号:</div>
          <div class="content">{{ applyer.userNo }}</div>
        </div>
        <div class="secondSeperate"></div>
        <div class="uavTitle">无人机匹配</div>
        <!-- <div class="uavTitle" v-if="!isWaitConfirm">无人机匹配</div>
        <div class="uavTitle" v-else @click="choosePlaneDialog()">
          <span>无人机匹配(点击修改)</span>
        </div> -->
        <div class="uavInfo">
          <!-- <div class="pic" @click="choosePlaneDialog()"> -->
          <div class="pic">
            <img :src="uav.uavmodel.pic_url" />
          </div>
          <div class="uavBasicInfo">
            <div class="title">名称：{{ uav.name }}</div>
            <div class="uavBasicInfoDetail">
              <div class="left">
                <div class="leftContent">编号：{{ uav.uas_serial_id }}</div>
                <div class="leftContent">
                  类型：{{ uav.uavmodel.uav_type_name }}
                </div>
                <div class="leftContent">型号：{{uav.uav_model_name}}</div>
              </div>
              <div class="right">
                <div class="rightContent">机载通信：{{uav.airborne_communication_name}}</div>
                <div class="rightContent">所属部门：{{uav.department_name}}</div>
                <div class="rightContent">所属区域：{{uav.area_name ? uav.area_name + '/' + uav.station_name : ''}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="goodsDetail">货物详情</div>
      </div>
      <div class="rightBottom">
        <div class="rightContentTable" ref="rightContentTable">
          <el-table
            :data="goodsList"
            class="goodsList"
            ref="goodsList"
            :height="goodsInfoTableHeight"
            :row-style="{ height: '40px' }"
            :cell-style="changeCellStyle"
            :row-class-name="goodsListRowClassName"
            tooltip-effect="light"
          >
            <el-table-column
              label="序号"
              align="center"
              prop="index"
              min-width="60"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="local_id"
              label="货物编号"
              align="center"
              min-width="80"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="体积（长*宽*高）/cm"
              align="center"
              min-width="100"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.goods_length }}* {{ scope.row.goods_width }}*
                  {{ scope.row.goods_height }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="重量/kg"
              align="center"
              min-width="60"
              prop="goods_weight"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="attributes"
              label="属性"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="goods_type_name"
              label="货物类型"
              align="center"
              min-width="80"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="goods_package_name"
              label="包装"
              align="center"
              min-width="80"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="goods_secrecy_id"
              label="密级"
              align="center"
              min-width="40"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.goods_secrecy_id === 0">非<span>密</span></span>
                <span v-else-if="scope.row.goods_secrecy_id === 1">秘<span>密</span></span>
                <span v-else-if="scope.row.goods_secrecy_id === 2">机<span>密</span></span>
                <span v-else-if="scope.row.goods_secrecy_id === 3">绝<span>密</span></span>
              </template> </el-table-column
            ><el-table-column
              prop="deliver_confirm"
              label="是否核实"
              align="center"
              min-width="50"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    flight.flight_status !== 40
                    || (flight.flight_status === 40 && scope.row.deliver_confirm === 1)
                  "
                >
                  <i class="el-icon-goods-checked-img" slot="prefix"></i>
                </span>
                <span v-else>
                  <i class="el-icon-close"></i>
                </span>
              </template> </el-table-column
            ><el-table-column label="操作" min-width="60" align="center">
              <template slot-scope="scope">
                <div
                  @click="checkGoods(scope.row)"
                  class="goodsCheckDiv"
                  v-show="isWaitConfirm"
                >
                  <i class="el-icon-goods-check-img" slot="prefix"></i>
                  <span class="goodsCheck">货物核实</span>
                </div>
                <div class="goodsCheckDiv" v-show="!isWaitConfirm">
                  <i class="el-icon-goods-checked-img" slot="prefix"></i>
                </div>
              </template> </el-table-column
          ></el-table>
        </div>
        <el-button
          :class="submitButton"
          v-if="isWaitConfirm"
          @click="submit"
          :disabled="submitButtonDisable"
        >
          提交
        </el-button>
      </div>
      
    </div>
    <!-- 货物核实模态框 -->
    <el-dialog
      :visible.sync="checkDialogVisible"
      :close-on-click-modal="false"
      width="349px"
      class="checkDialog"
    >
      <span slot="title" class="title">
        <i class="el-icon-goods-check-title-img" slot="prefix"></i>货物核实
      </span>
      <div class="checkDialogContent">
        <el-form
          ref="goodsForm"
          :model="goodsForm"
          :rules="goodsRules"
          class="goodsForm"
          @submit.native.prevent
        >
          <el-form-item label="货物编号:">
            {{ goodsForm.local_id }}
          </el-form-item>
          <el-form-item label="长/cm:" prop="goods_length">
            <el-input-number
              class="inputNumber"
              :min="1"
              :max="10000"
              size="mini"
              v-model="goodsForm.goods_length"
              @keyup.enter.native="confirmCheck('goodsForm')"
            >
            </el-input-number
          ></el-form-item>
          <el-form-item label="宽/cm:" prop="goods_width">
            <el-input-number
              class="inputNumber"
              :min="1"
              :max="10000"
              size="mini"
              v-model="goodsForm.goods_width"
              @keyup.enter.native="confirmCheck('goodsForm')"
            >
            </el-input-number
          ></el-form-item>
          <el-form-item label="高/cm:" prop="goods_height">
            <el-input-number
              class="inputNumber"
              :min="1"
              :max="10000"
              size="mini"
              v-model="goodsForm.goods_height"
              @keyup.enter.native="confirmCheck('goodsForm')"
            >
            </el-input-number></el-form-item
          ><el-form-item label="重量/kg:" prop="goods_weight">
            <el-input-number
              class="inputNumber"
              :min="1"
              :max="10000"
              size="mini"
              v-model="goodsForm.goods_weight"
              @keyup.enter.native="confirmCheck('goodsForm')"
            >
            </el-input-number></el-form-item
          ><el-form-item label="货物属性:">
            <el-checkbox-group
              class="attributes"
              v-model="goodsForm.goods_attribute"
            >
              <div>
                <el-checkbox label="0">易碎性</el-checkbox>
                <el-checkbox label="1">易爆性</el-checkbox>
              </div>
              <div class="attributeLine">
                <el-checkbox label="2">易燃性</el-checkbox>
                <el-checkbox label="3">腐蚀性</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="密级:" style="margin-top: 52px">
            <el-select
              popper-class="selectPopperClass"
              v-model="goodsForm.goods_secrecy_id"
              class="selectClass"
            >
              <el-option
                v-for="goodsSecrecy in goodsSecrecies"
                :key="goodsSecrecy.label"
                :label="goodsSecrecy.label"
                :value="goodsSecrecy.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="类型:" style="margin-top: 9px">
            <el-select
              popper-class="selectPopperClass"
              v-model="goodsForm.goods_type_id"
              class="selectClass"
            >
              <el-option
                v-for="goodsType in goodsTypes"
                :key="goodsType.id"
                :label="goodsType.name"
                :value="goodsType.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="包装:" style="margin-top: 9px">
            <el-select
              popper-class="selectPopperClass"
              v-model="goodsForm.goods_package_id"
              class="selectClass"
            >
              <el-option
                v-for="goodsPackage in goodsPackages"
                :key="goodsPackage.id"
                :label="goodsPackage.name"
                :value="goodsPackage.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="formItemBtnRow">
        <el-button
          type="primary"
          @click="confirmCheck('goodsForm')"
          class="confirmBtn"
          >确 定</el-button
        >
        <el-button @click="concelCheck()" class="cancelBtn">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 点击扫描模态框 -->
    <el-dialog
      :visible.sync="codeDialogVisible"
      :close-on-click-modal="false"
      width="402px"
      class="codeDialog"
    >
      <span slot="title" class="title">
        <i class="el-icon-goods-code-title-img" slot="prefix"></i>提示
      </span>
      <div class="content">
        <div class="title">未找到设备，请手动输入编码</div>
        <el-input class="inputNoClass" v-model="local_id"></el-input>
      </div>
      <div class="formItemBtnRow">
        <el-button type="primary" @click="confirmCode()" class="confirmBtn">确 定</el-button>
        <el-button @click="cancelCode()" class="cancelBtn">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 无人机匹配模态框 -->
    <!-- <el-dialog
      :visible.sync="choosePlaneDialogVisible"
      :close-on-click-modal="false"
      width="1550px"
      class="choosePlaneDialog"
    >
      <span slot="title" class="title">
        <i class="el-icon-uav-title-img" slot="prefix"></i>飞机列表
      </span>
      <el-table
        :data="planeList"
        @row-click="clickPlaneRow"
        ref="planeList"
        height="366"
        :row-style="{ height: '40px' }"
        :cell-style="changeCellStyle"
        :row-class-name="planeListRowClassName"
        tooltip-effect="light"
        class="taskTable"
      >
        <el-table-column
          prop="index"
          label="序号"
          min-width="60"
          :show-overflow-tooltip="true"
          align="center"
        >
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="choosedPlaneId">{{
              scope.row.index
            }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="uas_serial_id"
          label="编号"
          min-width="60"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column label="飞机图片" min-width="160" align="center">
          <template slot-scope="scope">
            　　　　<img
              v-if="null !== scope.row.uavmodel.pic_url"
              :src="scope.row.uavmodel.pic_url"
              width="218"
              height="96"
              class="planeImg"
            />
            　　</template
          >
        </el-table-column>
        <el-table-column
          prop="uavmodel.uav_type_name"
          label="类型"
          min-width="60"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="uavmodel.name"
          label="型号"
          min-width="60"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="uavmodel.uav_ceiling"
          label="升限"
          min-width="50"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="uavmodel.max_payload"
          label="最大载荷"
          min-width="50"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="airborne_communication_name"
          label="通讯"
          min-width="50"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="uavmodel.max_fly_time"
          label="续航时间"
          min-width="50"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="uavmodel.cruise_speed"
          label="巡航速度"
          min-width="50"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="出厂"
          min-width="100"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column
        ><el-table-column
          prop="uavmodel.company_name"
          label="生产厂商"
          min-width="100"
          :show-overflow-tooltip="true"
          align="center"
        >
        </el-table-column>
      </el-table>
      <div class="planeItemBtnRow">
        <el-button type="primary" @click="confirmPlane()" class="confirmBtn"
          >确 定</el-button
        >
        <el-button @click="choosePlaneDialogVisible = false" class="cancelBtn"
          >取 消</el-button
        >
      </div>
    </el-dialog> -->
  </div>
</template>

<script type="text/javascript">
import { secrecyStatus } from '../../common/dictionary'

import minimum from "../../assets/img/home/minimumer.png";
import secondary from "../../assets/img/home/secondaryer.png";
import highest from "../../assets/img/home/highester.png";
import codeBefore from "../../assets/img/home/codeBefore.png";
import uav from "../../assets/img/home/uav.jpg";
import tooltipOver from "../tools/tooltipOver";
export default {
  name: "ReceivingGoods",
  props: ["userInfo"],
  data() {
    return {
      // 定义飞行状态码，用来判断是否显示提交按钮以及在计划列表和待收货中设置货物详情列表的高度
      flightStatus: 0,
      // 定义左侧表格初始高度
      taskPlanTableAutoHeight: 200,
      // 用来存储浏览器高度
      windowHeight: 0,
      planNum: 0,
      waitConfirmNum: 0,
      confirmedNum: 0,
      opacityOfPlan: "opacity: 1;",
      opacityOfWaitConfirm: "opacity: 0.4;",
      opacityOfConfirmed: "opacity: 0.4;",
      openTab: "plan",
      isDetail: false,
      isWaitConfirm: false,
      goodsInfoTableHeight: 303,
      queryForm: {
        isConfirm: "", //""为计划列表，0为待收货，1为已收货
        keyword: "", // 搜索关键字字段
        currentpage: 1, //当前页码
        pagesize: 0, //不分页,传0
      },
      priority: minimum,
      codeBefore: codeBefore,
      codeDivClass: "code",
      priorityClassName: "minimum",
      taskList: [], //任务列表
      openedId: null, //已展开的任务
      local_id: "", //手动输入编号
      flight: {}, // 计划信息
      applyer: {}, //提报人
      uav: { uavmodel: {} }, //无人机
      goodsName: "", //货物名称
      goodsList: [], //货物列表
      goodsForm: {}, //货物表单
      goodsRules: {
        goods_length: [
          { required: true, message: "请填写货物长度~", trigger: "blur" },
        ],
        goods_width: [
          { required: true, message: "请填写货物宽度~", trigger: "blur" },
        ],
        goods_height: [
          { required: true, message: "请填写货物高度~", trigger: "blur" },
        ],
        goods_weight: [
          { required: true, message: "请填写货物重量~", trigger: "blur" },
        ],
      },
      submitButton: "submitBeforeButton",
      submitButtonDisable: true,
      checkDialogVisible: false, //货物核实弹框
      codeDialogVisible: false, //扫码输入弹框
      choosePlaneDialogVisible: false, //选择飞机弹框
      choosedPlaneId: null, //已选择的无人机id
      choosedPlane: {}, //已选择的无人机
      planeList: [], //飞机列表
      // 类型
      goodsTypes: [],
      // 包装
      goodsPackages: [],
      // 密级
      goodsSecrecies: secrecyStatus,
    };
  },
  components: {
    "tooltip-over": tooltipOver,
  },
  methods: {
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        showCancelButton: false,
      });
    },
    // 切换至计划列表tab（默认显示计划列表）
    plan() {
      if (this.openTab !== "plan") {
        this.opacityOfPlan = "opacity: 1;";
        this.opacityOfWaitConfirm = "opacity: 0.4;";
        this.opacityOfConfirmed = "opacity: 0.4;";
        this.isDetail = false;
        this.queryForm.isConfirm = ""; //""为计划列表，0为待收货，1为已收货
        this.getConfrimRelationListByDestination();
      }
      this.openTab = "plan";
    },
    // 切换至待确认tab
    waitConfirm() {
      if (this.openTab !== "waitConfirm") {
        this.opacityOfPlan = "opacity: 0.4;";
        this.opacityOfWaitConfirm = "opacity: 1;";
        this.opacityOfConfirmed = "opacity: 0.4;";
        this.isDetail = false;
        this.queryForm.isConfirm = 0; //""为计划列表，0为待收货，1为已收货
        this.getConfrimRelationListByDestination();
      }
      this.openTab = "waitConfirm";
    },
    // 切换至确认tab
    confirmed() {
      if (this.openTab !== "confirmed") {
        this.opacityOfPlan = "opacity: 0.4;";
        this.opacityOfWaitConfirm = "opacity: 0.4;";
        this.opacityOfConfirmed = "opacity: 1;";
        this.isDetail = false;
        this.queryForm.isConfirm = 1; //""为计划列表，0为待收货，1为已收货
        this.getConfrimRelationListByDestination();
      }
      this.openTab = "confirmed";
    },
    // 获取收货-待收货与已收货-数量统计信息
    getConfirmRelationStaticByCustomerConfirme() {
      this.getRequest(
        "/uav-task-server/confirmrelation/getConfrimRelationStaticByDestination.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            // this.planNum = data.AllFlight;
            // 计划列表的个数 = 待收货数量 + 已收货数量
            this.planNum = data.waitingReceive + data.received;
            this.waitConfirmNum = data.waitingReceive;
            this.confirmedNum = data.received;
          } else {
            this.planNum = 0;
            this.waitConfirmNum = 0;
            this.confirmedNum = 0;
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务统计获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    choosePlaneDialog() {
      if (this.isWaitConfirm) {
        // 无人机查询
        // this.queryUavList();
        this.choosePlaneDialogVisible = true;
      }
    },
    // 无人机查询
    // queryUavList() {
    //   let station_id = this.flight.station_id;
    //   this.choosedPlaneId = this.flight.plane_id;
    //   this.getRequest(
    //     "/basic-info-server/taskPlan/queryUavList.do?station_id=" + station_id
    //   )
    //     .then((res) => {
    //       res = res.data;
    //       if (0 == res.code) {
    //         if (null != res.data && !this.isEmptyArray(res.data)) {
    //           let planeList = res.data;
    //           if (planeList && planeList.length > 0) {
    //             planeList.forEach((plane) => {
    //               let uavmodel = plane.uavmodel;
    //               if (uavmodel && uavmodel.pic_url) {
    //                 uavmodel.pic_url = "/minio/" + uavmodel.pic_url;
    //               } else {
    //                 uavmodel.pic_url = null;
    //               }
    //             });
    //           }
    //           this.planeList = planeList;
    //         } else {
    //           this.planeList = [];
    //         }
    //       } else if (res.code != 401) {
    //         let msg = "啊哦,无人机查询失败~";
    //         if (!this.isEmptyStr(res.msg)) {
    //           msg = res.msg;
    //         }
    //         msg = "<i class='el-icon-warn-tip'></i>" + msg;
    //         this.$confirm(msg, "提示", {
    //           confirmButtonText: "好的",
    //           customClass: "confirmClass-style",
    //           iconClass: "",
    //           confirmButtonClass: "confirm",
    //           dangerouslyUseHTMLString: true,
    //           showCancelButton: false,
    //         });
    //       }
    //     })
    //     .catch((error) => {});
    // },
    // 飞机列表->弹框->确定
    confirmPlane() {
      let choosedPlane = this.choosedPlane;
      if (choosedPlane.id) {
        this.uav = choosedPlane;
      }
      this.choosePlaneDialogVisible = false;
    },
    
    // 货物核实->弹框->确认按钮
    confirmCheck(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.dealAttribute();
          let params = {
            ...this.goodsForm,
            deliver_confirm: 1,
            pickup_confirm: null,
            receive_confirm: null,
          };
          this.postJsonRequest(
            "/uav-task-server/goods/updateGoodsById.do",
            params
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.queryFlight(this.flight.id);
              this.checkDialogVisible = false;
              this.$message({
                message: "提交成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "confirmClass-style",
                iconClass: "",
                confirmButtonClass: "confirm",
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
              });
            }
          });
        }
      });
    },
    // 货物核实->弹框->取消按钮
    concelCheck() {
      this.queryFlight(this.flight.id);
      this.checkDialogVisible = false;
    },
    dealAttribute() {
      let goods_attribute = this.goodsForm.goods_attribute;
      if (goods_attribute && goods_attribute.length > 0) {
        if (goods_attribute.indexOf("0") > -1) {
          this.goodsForm.goods_attribute_id = 1;
        } else {
          this.goodsForm.goods_attribute_id = 0;
        }
        if (goods_attribute.indexOf("1") > -1) {
          this.goodsForm.goods_explosible_id = 1;
        } else {
          this.goodsForm.goods_explosible_id = 0;
        }
        if (goods_attribute.indexOf("2") > -1) {
          this.goodsForm.goods_inflammable_id = 1;
        } else {
          this.goodsForm.goods_inflammable_id = 0;
        }
        if (goods_attribute.indexOf("3") > -1) {
          this.goodsForm.goods_cautery_id = 1;
        } else {
          this.goodsForm.goods_cautery_id = 0;
        }
      } else {
        this.goodsForm.goods_attribute_id = 0;
        this.goodsForm.goods_explosible_id = 0;
        this.goodsForm.goods_inflammable_id = 0;
        this.goodsForm.goods_cautery_id = 0;
      }
    },
    confirmCode() {
      this.codeDialogVisible = false;
      this.submitButton = "submitButton";
      this.submitButtonDisable = false;
    },
    cancelCode() {
      this.codeDialogVisible = false;
      this.submitButton = "submitBeforeButton";
      this.codeDivClass = "code";
      // 点击 -点击扫码的取消按钮 - 提交按钮置灰禁用 
      this.submitButtonDisable = true;
    },
    choosePriority() {
      let priority = this.flight.priority;
      if (1 === priority) {
        this.priority = minimum;
        this.priorityClassName = "minimum";
      } else if (2 === priority) {
        this.priority = secondary;
        this.priorityClassName = "secondary";
      } else if (3 === priority) {
        this.priority = highest;
        this.priorityClassName = "highest";
      }
    },
    // 获取货物类别
    getGoodsTypeList() {
      this.getRequest("/uav-task-server/goodstype/getGoodsTypeList.do").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            this.goodsTypes = oData.data;
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>啊哦,货物类别获取失败~";
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "confirmClass-style",
              iconClass: "",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 获取货物包装
    getGoodsPackageList() {
      this.getRequest(
        "/uav-task-server/goodpackage/getGoodsPackageList.do"
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.goodsPackages = oData.data;
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,货物包装获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    checkGoods(row) {
      this.getGoodsTypeList();
      this.getGoodsPackageList();
      this.goodsForm = row;
      this.checkDialogVisible = true;
      let goods_attribute = [];

      if (this.goodsForm.goods_attribute_id === 1) {
        goods_attribute.push("0");
      }
      if (this.goodsForm.goods_explosible_id === 1) {
        goods_attribute.push("1");
      }
      if (this.goodsForm.goods_inflammable_id === 1) {
        goods_attribute.push("2");
      }
      if (this.goodsForm.goods_cautery_id === 1) {
        goods_attribute.push("3");
      }
      this.$set(this.goodsForm, "goods_attribute", goods_attribute); //触发更新视图
    },
    submit() {
      let tips = "<i class='el-icon-warn-tip'></i>是否确定收货?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel",
      })
        .then(() => {
          let params = {
            ...this.flight,
            id: this.openedId,
            flight_status: 90,
          };
          this.postJsonRequest(
            "/uav-task-server/confirmrelation/updateConfirmRelationByDeliveryConfirm.do",
            params
          ).then((res) => {
            let oData = res.data;
            if (oData.code === 0) {
              this.isDetail = false;
              this.getConfirmRelationStaticByCustomerConfirme();
              this.getConfrimRelationListByDestination();
              this.$message({
                message: "提交成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "confirmClass-style",
                iconClass: "",
                confirmButtonClass: "confirm",
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取列表信息--计划列表-待收货-已收货
    getConfrimRelationListByDestination() {
      const param = this.getQueryParam(this.queryForm);
      this.getRequest(
        "/uav-task-server/confirmrelation/getConfrimRelationListByDestination.do?" +
          param
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.$data.taskList = data.list;
          } else {
            this.$data.taskList = [];
          }
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>啊哦,任务列表获取失败~";
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    // 点击左侧表格显示右侧计划详细信息
    clickTaskRow(row) {
      this.flightStatus = row.flight_status
      this.openedId = row.id;
      this.isDetail = true;
      this.submitButton = "submitBeforeButton";
      this.submitButtonDisable = true;
      this.codeDivClass = "code";
      this.$refs.taskList.toggleRowSelection(row);
      // 判断是否显示 “点击扫码” 和 “货物核实”，判断码为70以及在 待确认列表中，通过样式透明度来判断
      if (70 === row.flight_status && this.opacityOfWaitConfirm === "opacity: 1;") {
        this.isWaitConfirm = true;
        // this.goodsInfoTableHeight = 217;
      } else {
        this.isWaitConfirm = false;
        // this.goodsInfoTableHeight = 303;
      }
      this.choosedPlane = {};
      this.$nextTick(() => {
        this.queryFlight(row.flight_id);
      });

      // 右侧屏幕自适应
      this.setGoodsInfoHeight()
    },
    // 设置右侧货物详情表格的高度
    setGoodsInfoHeight() {
      // 右侧自适应监听 ， 11为表格的margin-top（11px）
      if (this.flightStatus === 70 && this.opacityOfWaitConfirm === "opacity: 1;") {
        this.goodsInfoTableHeight = document.body.clientHeight - 718 - 11;
      } else {
        this.goodsInfoTableHeight = document.body.clientHeight - 637 - 11;
      }
    },
    clickPlaneRow(row) {
      this.flight.plane_id = row.id;
      this.choosedPlaneId = row.id;
      this.choosedPlane = row;
    },
    // 根据id获取计划信息
    queryFlight(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id)
       .then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              if (data.flight) {
                this.flight = data.flight;
              } else {
                this.flight = {};
              }
              if (data.applyer) {
                this.applyer = data.applyer;
              } else {
                this.applyer = {};
              }
              if (data.lsgoods) {
                this.goodsList = data.lsgoods;
              } else {
                this.goodsList = [];
              }
              let choosedPlane = this.choosedPlane;
              if (choosedPlane.id) {
                this.flight.plane_id = this.choosedPlaneId;
                this.uav = choosedPlane;
              } else if (data.uav) {
                this.uav = data.uav;
                let uavmodel = data.uav.uavmodel;
                if (uavmodel && uavmodel.pic_url) {
                  this.uav.uavmodel.pic_url = "/minio/" + uavmodel.pic_url;
                }
              } else {
                this.uav = { uavmodel: {} };
              }
              this.choosePriority();
              this.dealDataAfterGetDetail();
            }
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>啊哦,计划信息获取失败~";
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "confirmClass-style",
              iconClass: "",
              confirmButtonClass: "confirm",
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      // 设置货物列表信息 start
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        this.goodsName = goodsList[0].goods_name;
        goodsList.forEach(function (goods, index) {
          let attributes = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attributes.push("易碎性");
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attributes.push("易爆性");
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attributes.push("易燃性");
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attributes.push("腐蚀性");
          }
          let attributesStr = "";
          for (let i = 0, len = attributes.length; i < len; i++) {
            if (i === len - 1) {
              attributesStr += attributes[i];
            } else {
              attributesStr += attributes[i] + ",";
            }
          }
          _this.$set(goods, "attributes", attributesStr); //触发更新视图
        });
        _this.goodsList = goodsList;
      } else {
        this.goodsList = [];
      }
    },
    clickToShowCode() {
      this.codeDivClass = "codeAfter";
      this.codeDialogVisible = true;
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    goodsListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    planeListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      if (this.choosedPlaneId === row.id) {
        return "focusPictureRowStyle";
      }
      return "pictureRowStyle";
    },

    // 浏览器窗口大小变化监听的绑定事件
    eventListenerWindowSize() {
      return (() => {
        this.windowHeight= document.body.clientHeight;
      })()
    }
  },
  mounted() {
    this.getConfirmRelationStaticByCustomerConfirme();
    this.$nextTick(function () {
      this.getConfrimRelationListByDestination();
    });
    window.statisicsTimer = setInterval(
      this.getConfirmRelationStaticByCustomerConfirme,
      28000
    ); //28秒轮询一次
    window.queryTimer = setInterval(
      this.getConfrimRelationListByDestination,
      30000
    ); //30秒轮询一次
    
    // 添加浏览器窗口大小变化监听事件
    window.addEventListener("resize", this.eventListenerWindowSize);
  },
  beforeDestroy() {
    if (window.statisicsTimer) {
      clearInterval(window.statisicsTimer);
      window.statisicsTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }

    // 移除浏览器窗口大小变化监听
    window.removeEventListener("resize", this.eventListenerWindowSize);
  },
  watch: {
    // 监听浏览器窗口大小变化
    windowHeight: {
      handler() {
        // 540为除this.$refs.contentTable.offsetHeight高度之外的高度（浏览器高度 - this.$refs.contentTable.offsetHeight 的高度）
        // 15为表格的margin-top（15px）
        this.taskPlanTableAutoHeight = document.body.clientHeight - 540 - 15;
        // 右侧自适应
        this.setGoodsInfoHeight()
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/home/ReceivingGoods.css";
</style>
<style>
.checkDialogContent .el-form-item__label {
  width: 150px;
  font-size: 16px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
.checkDialogContent .el-checkbox__label {
  color: #ffffff;
}
.checkDialogContent .el-form-item__content {
  margin-left: -75px;
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
.checkDialogContent .inputClass .el-input__inner {
  width: 140px;
  height: 34px !important;
  background-color: rgba(0, 131, 253, 0.1) !important;
  border: 1px solid #0083fd !important;
  border-radius: 6px;
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
.inputNumber .el-input__inner {
  margin-left: 34px;
  margin-top: 0;
  /* width: 76px; */
  height: 34px;
  background: rgba(0, 131, 253, 0.1);
  color: rgba(255, 255, 255, 1);
  border: 1px solid #0083fd;
  border-radius: 6px;
}
.inputNumber .el-input-number__decrease,
.inputNumber .el-input-number__increase {
  width: 28px;
  height: 32px;
  background: rgba(0, 131, 253, 0.1);
  border: 1px solid #0083fd;
  border-radius: 6px;
}
.inputNumber .el-input-number__increase {
  margin-right: -68px;
}
.inputNumber .el-icon-minus,
.inputNumber .el-icon-plus {
  position: absolute;
  top: 10px;
  right: 8px;
  color: rgba(255, 255, 255, 1);
}
.inputNumber .el-icon-minus:hover,
.inputNumber .el-icon-plus:hover {
  color: rgba(255, 255, 255, 0.8);
}
.selectClass .el-input__inner {
  height: 34px;
  background: rgba(0, 131, 253, 0.1);
  color: rgba(255, 255, 255, 1);
  border: 1px solid #0083fd;
  border-radius: 6px;
}
.selectClass:hover .el-input__inner {
  border-color: #0083fd;
}
.inputNoClass .el-input__inner {
  height: 48px;
  background: rgba(0, 131, 253, 0.1);
  border: 1px solid #0083fd;
  border-radius: 6px;
  font-size: 18px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
/* 表格单选框样式  start */
.taskTable .el-radio__inner {
  width: 11px;
  height: 11px;
  background: #9a9a9a;
}
.taskTable .el-radio__label {
  font-size: 12px;
  font-family: Arial;
  font-weight: 400;
  color: #ffffff;
}
.taskTable .el-radio__input.is-checked .el-radio__inner {
  border: 2px solid #ffffff;
  background: #ffa63e;
}
.taskTable .el-radio__inner::after {
  background-color: #ffa63e;
}
/* 表格单选框样式  end */
</style>



// WEBPACK FOOTER //
// src/components/home/ReceivingGoods.vue